import './style.scss'

import React, { Component } from 'react'

import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import Spinner from 'components/UI/Spinner'
import chevronIcon from 'img/chevron.svg'
import classNames from 'classnames'
import onClickOutside from 'react-onclickoutside'

class DropDown extends Component {
    constructor(props) {
        super(props)
        this.dropDownBody = React.createRef()
    }

    componentDidUpdate(prevProps) {
        const { expanded, scrollable } = this.props
        if (scrollable && expanded && !prevProps.expanded) {
            this.dropDownBody.current.scrollTop = 0
        }
    }

    handleClickOutside() {
        if (this.props.expanded && this.props.onClose) {
            this.props.onClose()
        }
    }

    handleClick() {
        if (!this.disabled) {
            this.props.onClick()
        }
    }

    render() {
        const {
            title,
            type,
            className,
            expanded,
            scrollable,
            loading,
            icon,
            disabled,
            invalid,
            ariaLabel,
        } = this.props
        const classes = classNames({
            [`${className}`]: className,
            'drop-down': true,
            'drop-down--expanded': expanded,
            'drop-down--scrollable': scrollable,
            'drop-down--disabled': disabled,
        })
        const buttonClasses = classNames({
            'drop-down__button': true,
            'drop-down__button--invalid': invalid,
        })
        return (
            <div className={classes}>
                <button
                    className={buttonClasses}
                    type={type}
                    onClick={() => this.handleClick()}
                    disabled={disabled}
                    aria-label={ariaLabel || title}
                >
                    {icon && icon}
                    {!loading && title && <span className="drop-down__title">{title}</span>}
                    {loading && <Spinner color={'0,0,0'} />}
                    {!disabled && (
                        <Icon className="drop-down__icon" svg={chevronIcon} size="small" />
                    )}
                </button>
                <div ref={this.dropDownBody} className="drop-down__body">
                    {expanded && <div className="drop-down__content">{this.props.children}</div>}
                </div>
            </div>
        )
    }
}

DropDown.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.element,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    className: PropTypes.string,
    expanded: PropTypes.bool,
    scrollable: PropTypes.bool,
    loading: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
}

export default onClickOutside(DropDown)
